var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Federal Trade Commission Guidelines ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("p", [
                    _vm._v(
                      " GreenGeeks requires that each affiliate comply with the rules and guidelines expressed by the FTC (Federal Trade Commission) and that failure to do so may result in removal from our affiliate program and cancellation of commissions. In December 2009 the FTC released guidelines which require transparency by any affiliate who uses reviews, rankings or testimonials to promote products or services which would disclose the fact to website visitors that the affiliate is compensated for their reviews, rankings or testimonials."
                    )
                  ]),
                  _c("p", [
                    _vm._v("Please read the FTC’s: "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "http://www.ftc.gov/os/2009/10/091005revisedendorsementguides.pdf"
                        }
                      },
                      [
                        _vm._v(
                          "Guides Concerning the Use of Endorsements and Testimonials in Advertising."
                        )
                      ]
                    )
                  ]),
                  _c("p", [
                    _c("b", [
                      _c("u", [
                        _vm._v(
                          "As an affiliate, how can you comply with the FTC’s rules?"
                        )
                      ])
                    ])
                  ]),
                  _c("p", [
                    _vm._v(
                      "To comply with the FTC rules you should meet four basic requirements regarding your disclosure to your website visitors that you may receive compensation for your reviews, recommendations, rankings, etc.. Your disclosures should be frequent, clear, conspicuous and require no additional scrolling or other type of action (like hovering) to be able to see the disclosure."
                    )
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "row"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-sm-6"
                        },
                        [
                          _c("ol", [
                            _c("li", [
                              _vm._v(
                                "The FTC advises that your disclosure should be on any page that has a review, recommendation, comment or article that promotes any product or service for which you receive an affiliate commission. "
                              )
                            ]),
                            _c("br"),
                            _c("li", [
                              _vm._v(
                                "The FTC further advises that it should be clear to the reader that as an affiliate you may receive compensation for your reviews, recommendations, rankings, etc. "
                              )
                            ]),
                            _c("br"),
                            _c("li", [
                              _vm._v(
                                "The disclosure should be in text which is at least as large as the other text on your website page and should be in contrast with both the background of the website page and with the other text on that page. So for example if your website page background is white and your text is black, you should use a dark color (other than and distinctive compared to Black Text) like bright blue for your disclosure’s text. "
                              )
                            ]),
                            _c("br"),
                            _c("li", [
                              _vm._v(
                                "The disclosure should also start with the word “Disclosure” and it should require no scrolling or any other type of user action to have the disclosure be immediately evident to your website visitor. "
                              )
                            ])
                          ])
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "col-sm-6"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "box"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "box-content"
                                },
                                [
                                  _c(
                                    "blockquote",
                                    {
                                      staticStyle: {
                                        "font-size": "13px"
                                      }
                                    },
                                    [
                                      _c("p", [
                                        _c("b", [
                                          _c("u", [
                                            _vm._v("Example Disclosure:")
                                          ])
                                        ])
                                      ]),
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            color: "#2196f3!important"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " Disclosure: This website is independently owned and operated. We are a professional review website which receives compensation from the companies whose products and/or services we review. We tested and reviewed the web hosting sites ranked here and the opinions expressed here are our own. "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _c("p", [
                    _c("b", [_c("u", [_vm._v("Additional Resources")])])
                  ]),
                  _c("p", [
                    _vm._v(
                      "If you have further questions regarding the FTC rules and your website you should consult with a legal advisor AND you may learn more from the FTC with their helpful guideline articles and information below:"
                    )
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "row"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-sm-12"
                        },
                        [
                          _c("ul", [
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "http://www.ftc.gov/os/2009/10/091005revisedendorsementguides.pdf"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Guides Concerning the Use of Endorsements and Testimonials in Advertising"
                                  )
                                ]
                              )
                            ]),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "http://business.ftc.gov/documents/bus71-ftcs-revised-endorsement-guideswhat-people-are-asking.pdf"
                                  }
                                },
                                [
                                  _vm._v(
                                    "The FTC’s Revised Endorsement Guides: What People are Asking"
                                  )
                                ]
                              )
                            ]),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "http://www.ftc.gov/bcp/edu/pubs/business/ecommerce/bus41.pdf"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Dot Com Disclosures: Information About Online Advertising"
                                  )
                                ]
                              )
                            ])
                          ])
                        ]
                      )
                    ]
                  ),
                  _c("p", [
                    _c("b", [_vm._v("Please Note:")]),
                    _vm._v(
                      " The information provided on this website page is intended as guidance only and is not intended as legal advice. Should you need more legal advice regarding how these rules pertain to your website you should seek a legal advisor."
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }